import React, { useState } from "react";
import moment from "moment";
import donations from "../../../data/donations";
import { ListFilter, PaymentFilter } from "./PaymentFilter";
import PaymentHeader from "./PaymentHeader";
import CollectionBox from "./CollectionBox";
import PaymentList from "./PaymentList";
import AuthorityLayout from "../../../components/layout/AuthorityLayout";

const mosjidName = process.env.REACT_APP_MOSJID_NAME;
const startDefaultDate = moment(new Date(Date.now() - 86400000)).format(
  "YYYY-MM-DD"
);
const endDefaultDate = moment(new Date()).format("YYYY-MM-DD");

const Payment = () => {
  const [startDate, setStartDate] = useState(startDefaultDate);
  const [endDate, setEndDate] = useState(endDefaultDate);
  const [selected, setSelected] = useState("All");
  const [listName, setListName] = useState("Masjid Donation");
  const [exportDate, setExportDate] = useState({
    startDate: startDefaultDate,
    endDate: endDefaultDate,
  });
  const [transactionUrl, setTransactionUrl] = useState(
    `/payment/${mosjidName}/transaction/summary?startDate=${startDefaultDate}&endDate=${endDefaultDate}`
  );
  const [itemsTransactionUrl, setItemsTransactionUrl] = useState(
    `payment/${mosjidName}/transaction/items/summary?startDate=${startDefaultDate}&endDate=${endDefaultDate}`
  );
  const [listUrl, setListUrl] = useState(
    `/payment/${mosjidName}/${listName}/list?startDate=${startDefaultDate}&endDate=${endDefaultDate}`
  );

  const submitHandler = () => {
    let tempTransactionUrl = `/payment/${mosjidName}/transaction/summary`;
    let tempItemsTransactionUrl = `payment/${mosjidName}/transaction/items/summary`;
    let tempListUrl = `/payment/${mosjidName}/${listName}/list`;

    if (startDate && endDate) {
      tempTransactionUrl += `?startDate=${startDate}&endDate=${endDate}`;
      tempItemsTransactionUrl += `?startDate=${startDate}&endDate=${endDate}`;
      tempListUrl += `?startDate=${startDate}&endDate=${endDate}`;
    }
    if (selected.toLowerCase() !== "all") {
      tempListUrl += `&status=${selected}`;
    }

    setTransactionUrl(tempTransactionUrl);
    setItemsTransactionUrl(tempItemsTransactionUrl);
    setListUrl(tempListUrl);
    setExportDate({ startDate, endDate });
  };

  const lisUrltHandler = (item) => {
    const tempListUrl = `/payment/${mosjidName}/${item}/list?startDate=${startDate}&endDate=${endDate}`;
    setListName(item);
    setListUrl(tempListUrl);
  };

  const seeAllHandler = () => {
    const tempListUrl = `/payment/${mosjidName}/${"all"}/list?startDate=${startDate}&endDate=${endDate}`;
    setListUrl(tempListUrl);
    setListName("All");
  };

  return (
    <AuthorityLayout>
      <PaymentHeader />
      <PaymentFilter
        startDate={startDate}
        endDate={endDate}
        selected={selected}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        setSelected={setSelected}
        submitHandler={submitHandler}
      />

      <CollectionBox
        title="Total Collections"
        tableTitle="Itemwise Transactions"
        tableHeader={["name", "transaction No", "amount", "export"]}
        tableUrl={itemsTransactionUrl}
        summaryTitle="Transactions"
        summaryUrl={transactionUrl}
        exportDate={exportDate}
      />
      <ListFilter
        options={donations.map((item) => item.authorTitle)}
        selected={listName}
        setSelected={lisUrltHandler}
        onClick={seeAllHandler}
      />
      <PaymentList url={listUrl} selected={listName} />
    </AuthorityLayout>
  );
};

export default Payment;
